<script>
  import { cancelTrade } from '../../lib/services/trade-service.js';

  let { isOpen = false, tradeId = null, onClose, onCancelled } = $props();

  let isCancelling = $state(false);

  async function handleCancel() {
    if (!tradeId || isCancelling) return;
    isCancelling = true;

    try {
      await cancelTrade(tradeId);
      onCancelled?.();
    } catch (err) {
      console.error('[CancelTradeModal] Error cancelling trade:', err);
    } finally {
      isCancelling = false;
    }
  }

  function handleOverlayClick(e) {
    if (e.target === e.currentTarget && !isCancelling) {
      onClose?.();
    }
  }
</script>

{#if isOpen}
  <!-- svelte-ignore a11y_no_static_element_interactions -->
  <!-- svelte-ignore a11y_click_events_have_key_events -->
  <div class="modal-overlay" onclick={handleOverlayClick}>
    <div class="cancel-trade-modal-content">
      <div class="trade-cancelled-icon">&#x1F6AB;</div>
      <h2>Cancel Trade?</h2>
      <p class="cancel-trade-message">
        This will permanently cancel the trade.
        <strong>Both parties will lose their selected cards.</strong>
      </p>
      <p class="cancel-trade-warning">This action cannot be undone.</p>

      <div class="cancel-trade-buttons">
        <button
          class="cancel-trade-btn cancel-trade-btn-keep"
          onclick={onClose}
          disabled={isCancelling}
        >
          Keep Trading
        </button>
        <button
          class="cancel-trade-btn cancel-trade-btn-cancel-light"
          onclick={handleCancel}
          disabled={isCancelling}
        >
          {isCancelling ? 'Cancelling...' : 'Cancel Trade'}
        </button>
      </div>
    </div>
  </div>
{/if}

<style>
  .modal-overlay {
    position: fixed;
    inset: 0;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 2000;
    padding: 1rem;
  }

  .cancel-trade-modal-content {
    background: white;
    padding: 1.5rem;
    border-radius: 16px;
    max-width: 320px;
    width: 90%;
    text-align: center;
    box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.15);
  }

  .cancel-trade-modal-content h2 {
    font-size: 1.25rem;
    font-weight: 600;
    color: #1f2937;
    margin: 0 0 0.75rem 0;
  }

  .trade-cancelled-icon {
    font-size: 3rem;
    margin-bottom: 0.5rem;
    color: #9ca3af;
  }

  .cancel-trade-message {
    font-size: 0.9rem;
    color: #4b5563;
    margin: 0 0 0.5rem 0;
    line-height: 1.4;
  }

  .cancel-trade-message :global(strong) {
    color: #1f2937;
  }

  .cancel-trade-warning {
    font-size: 0.8rem;
    color: #9ca3af;
    margin: 0 0 1.25rem 0;
  }

  .cancel-trade-buttons {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
  }

  .cancel-trade-btn {
    display: block;
    width: 100%;
    padding: 0.875rem 1rem;
    border: none;
    border-radius: 10px;
    font-size: 1rem;
    font-weight: 500;
    cursor: pointer;
    transition:
      background-color 0.15s,
      transform 0.1s;
    text-align: center;
  }

  .cancel-trade-btn:active {
    transform: scale(0.98);
  }

  .cancel-trade-btn:disabled {
    opacity: 0.5;
    cursor: not-allowed;
    transform: none;
  }

  .cancel-trade-btn-keep {
    background-color: #4b5563;
    color: white;
  }

  .cancel-trade-btn-keep:hover:not(:disabled) {
    background-color: #374151;
  }

  .cancel-trade-btn-cancel-light {
    background-color: #fee2e2;
    color: #dc2626;
  }

  .cancel-trade-btn-cancel-light:hover:not(:disabled) {
    background-color: #fecaca;
  }
</style>
